/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Value of the entry
 */
/**
 * @type AnalysisValue
 * Value of the entry
 * @export
 */
export type AnalysisValue = number | string;

